<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2b"><a id="page_ix"></a><b>Books for Wiser Living recommended by <i>Mother Earth News</i></b></h2>
<p class="noindent"><span><span class="dropcap">T</span><span class="small">ODAY, MORE THAN EVER BEFORE</span>, our society is seeking ways to live more conscientiously. To help bring you the very best inspiration and information about greener, more sustainable lifestyles, <i>Mother Earth News</i> is recommending select New Society Publishers books to its readers. For more than 30 years, <i>Mother Earth</i> has been North America’s “Original Guide to Living Wisely,” creating books and magazines for people with a passion for self-reliance and a desire to live in harmony with nature. Across the countryside and in our cities, New Society Publishers and <i>Mother Earth</i> are leading the way to a wiser, more sustainable world. For more information, please visit <a href="http://MotherEarthNews.com" target="_blank">MotherEarthNews.com</a></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Books.vue?07c1f67d